import { get, writable } from 'svelte/store';
import { navigate } from '../../app.logic';
import { ActivityService } from '../../services/activity.service';
import { CompanyService } from '../../services/company.service';
import { ContactService } from '../../services/contact.service';
import { getCustomFieldSchemas, initializeCustomFields, makeTableCustomFields } from '../../utils/CustomFieldEntities/custom-field-utils';
export const loading = writable(false);
export const filter = writable({ criteria: {} });
export const records = writable([]);
export const pagination = writable(null);
export const record = writable(null);
export const stats = writable(null);
export const comments = writable([]);
export const activities = writable([]);
export const channels = writable([]);
export const contactCompanies = writable([]);
export const companyContact = writable({});
export const customFieldsSchemas = writable([]);
export const tableCustomFields = writable([]);
export async function initList() {
    filter.set({ criteria: {}, params: null, sorting: "" });
    pagination.set({ currentPage: 1, totalPages: 0, totalRecords: 0 });
    record.set(null);
    await loadCustomFieldSchemas();
    await load();
}
export async function initDetail(oid) {
    record.set(null);
    stats.set(null);
    activities.set([]);
    contactCompanies.set([]);
    await loadCustomFieldSchemas();
    if (oid == 0) {
        let tmpRecord = { oid: 0 };
        tmpRecord.customFields = initializeCustomFields(get(customFieldsSchemas));
        record.set(tmpRecord);
    }
    else {
        let _resp = await ContactService.fetchContact(oid).toPromise();
        record.set(_resp.payload);
        await loadStats(oid);
        await loadActivities(oid);
        await loadChannels(oid);
        await loadCompanies(oid);
    }
}
async function loadCustomFieldSchemas() {
    let schemas = await getCustomFieldSchemas("CONTACTXXX");
    customFieldsSchemas.set(schemas);
    let tcf = await makeTableCustomFields(schemas, 'contact');
    tableCustomFields.set(tcf);
}
async function loadStats(customerOid) {
    // let _resp = await ContactService.fetchContactStats(customerOid).toPromise();
    // stats.set(_resp.payload);
}
export async function search() {
    pagination.set({ currentPage: 1, totalPages: 0, totalRecords: 0 });
    await load();
}
export async function load() {
    loading.set(true);
    try {
        let _filter = get(filter);
        let _pag = get(pagination);
        let _resp = await ContactService.getContacts(_filter, _pag.currentPage).toPromise();
        records.set(_resp.payload);
        pagination.set(_resp.pagination);
    }
    finally {
        loading.set(false);
    }
}
export function onCreate() {
    navigate(`/contact/0`);
}
export function onEdit(item) {
    navigate(`/contact/${item.oid}`);
}
export async function save() {
    let _record = get(record);
    return ContactService.saveContact(_record).toPromise();
}
export async function onDelete(item) {
    await ContactService.deleteContact(item.oid).toPromise();
    await load();
}
export function onPageChange(pageNumber) {
    pagination.set(Object.assign(Object.assign({}, get(pagination)), { currentPage: pageNumber }));
    load();
}
// ----------------------------------------------------------------------
// Activities
// ----------------------------------------------------------------------
export async function loadActivities(companyId) {
    let _resp = await ActivityService.getOpenActivities(companyId, 'Contact').toPromise();
    activities.set(_resp.payload);
}
export async function addActivity(event) {
    let act = event.detail;
    await ActivityService.saveActivity(act).toPromise();
    loadActivities(act.entityId);
}
export async function completeActivity(event) {
    let act = event.detail;
    await ActivityService.completeActivity(act.oid).toPromise();
    loadActivities(act.entityId);
}
// ----------------------------------------------------------------------
// Comments
// ----------------------------------------------------------------------
export async function loadComments(contactId) {
    let _resp = await ContactService.getContactComments(contactId).toPromise();
    comments.set(_resp.payload);
}
export async function addComment(event) {
    let comment = event.detail;
    await ContactService.saveContactComment(comment).toPromise();
    loadComments(comment.entityId);
}
export async function delComment(event) {
    let comment = event.detail;
    await ContactService.deleteContactComment(comment.oid).toPromise();
    loadComments(comment.entityId);
}
// ----------------------------------------------------------------------
// Channels
// ----------------------------------------------------------------------
export async function loadChannels(contactId) {
    let _resp = await ContactService.getContactChannels(contactId).toPromise();
    channels.set(_resp.payload);
}
export async function addChannel(event) {
    let channel = event.detail;
    await ContactService.saveContactChannel(channel).toPromise();
    loadChannels(channel.entityId);
}
export async function delChannel(event) {
    let channel = event.detail;
    await ContactService.deleteContactChannel(channel.oid).toPromise();
    loadChannels(channel.entityId);
}
// ----------------------------------------------------------------------
// Companies
// ----------------------------------------------------------------------
export async function loadCompanies(contactId) {
    let _resp = await ContactService.getContactCompanies(contactId).toPromise();
    contactCompanies.set(_resp.payload);
}
export async function saveCompanyContact(item) {
    let _contact = get(record);
    let _record = get(companyContact);
    _record.contactId = _contact.oid;
    return CompanyService.saveCompanyContact(_record).toPromise();
}
export async function onDeleteCompanyContact(item) {
    await CompanyService.deleteCompanyContact(item.oid).toPromise();
    await loadCompanies(item.companyContact.contactId);
}
